export const GitHubLink =
	'https://github.com/thutasann/optimzed-react/tree/main/src/pages';

export const GitHubTsPlaygroundLink =
	'https://github.com/thutasann/optimized-react/tree/main/src/playground';

export const ListData: string[] = [
	'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
	'Aliquam tincidunt mauris eu risus.',
	'Vestibulum auctor dapibus neque.',
	'Nunc dignissim risus id metus.',
	'Nunc dignissim risus id metus.',
	'Vivamus vestibulum ntulla nec ante.',
	'Praesent placerat risus quis eros.',
	'Fusce pellentesque suscipit nibh.',
	'Integer vitae libero ac risus egestas placerat.',
	'Vestibulum commodo felis quis tortor.',
	'Ut aliquam sollicitudin leo.',
	'Cras iaculis ultricies nulla.',
	'Donec quis dui at dolor tempor interdum.',
];
